module.exports = __webpack_public_path__ + "static/media/club_thumb.a801d7b8.jpg";